import { render, staticRenderFns } from "./packageOrder.vue?vue&type=template&id=e8808122&scoped=true"
import script from "./packageOrder.vue?vue&type=script&lang=js"
export * from "./packageOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8808122",
  null
  
)

export default component.exports